import React, { useState } from "react";
import { Button } from "../../components/template";

const quizData = [
  { question: "How would you describe your body build?", options: ["Lean", "Medium", "Large"] },
  { question: "How does your skin usually feel?", options: ["Dry, rough, chapped", "Sensitive, oily, gets sunburnt easily", "Thick, moist, and soft"] },
  { question: "How’s your natural complexion?", options: ["Dark, brownish, dry, or dull", "Fair, pinkish or golden", "Light, whitish, clear"] },
  { question: "How is your hair?", options: ["Dry, brown/black, knotted, brittle", "Fine, Straight, Red, Prone to balding, greying", "Thick, Oily, Wavy, Curly"] },
  { question: "Which of these is true for your body weight?", options: ["Low, tough to gain weight", "Medium, easy to gain & lose weight", "Overweight, tough to lose weight"] },
  { question: "How does your body temperature usually feel?", options: ["Cold, cold extremities", "High, feels warm, hot flashes, sweats", "Steady body temperature"] },
  { question: "How are your eyes?", options: ["Black/Brown", "Grey, Yellowish", "Blue, Liquid-y"] },
  { question: "How would you describe your way of speaking?", options: ["Speaks fast & unstructured", "Precise, clear to the point, sharp", "Slow, gentle"] },
  { question: "How’s your hunger generally?", options: ["Irregular, frequently skips meals", "Strong, Timely, Unbearable", "Good but manages to skip meals sometimes"] },
  { question: "How often do you feel thirsty?", options: ["Varies from day to day", "Often", "Rarely"] },
  { question: "How is your bowel movement usually?", options: ["Towards Constipation", "Loose - Thick", "Oily, Sluggish"] },
  { question: "How would you describe your weather tolerance?", options: ["Feel cold easily", "Feel hot easily", "Dislike dampness, prefer warm weather"] },
  { question: "How’s your energy level throughout the day?", options: ["Irregular, comes & goes in spurts", "Medium to high, can push more", "Good and long-lasting, good stamina"] },
  { question: "How is your memory usually?", options: ["Good short-term memory, but forgets easily", "Quick memory, accurate past and future", "Follows a plan, dislikes change"] }
];

const IntroPage = ({ onStart }) => (
  <div className="min-h-screen bg-[#F7F1EA] px-6 py-12 flex items-center justify-center">
    <div
      className="
        relative
        overflow-hidden
        rounded-[34px]
        max-w-5xl
        w-full
        h-[620px]
        shadow-[0_30px_80px_rgba(20,10,0,.12)]
      "
    >
      <img
        src="/assets/knowyourself/quiz/q1.jpg"
        alt="Prakriti Quiz"
        className="
          w-full
          h-full
          object-cover
          brightness-[.84]
          saturate-[.9]
        "
      />

      <div
        className="
          absolute
          inset-0
          bg-gradient-to-t
          from-black/90
          via-black/35
          to-transparent
        "
      />

      <div className="absolute top-6 left-6">
        <div
          className="
            px-4
            py-2
            rounded-full
            bg-white/10
            backdrop-blur-xl
            border
            border-white/10
            text-white
            text-xs
            tracking-[.08em]
          "
        >
          AYURVEDA ASSESSMENT
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 p-6">
        <div
          className="
            rounded-[28px]
            bg-white/10
            backdrop-blur-2xl
            border
            border-white/10
            p-8
          "
        >
          <h1
            className="
              text-[38px]
              md:text-[56px]
              leading-[1.05]
              tracking-[-0.03em]
              text-white
              mb-5
            "
          >
            Prakriti Quiz
          </h1>

          <p
            className="
              text-white/75
              text-[15px]
              leading-8
              mb-4
            "
          >
            Discover your Ayurvedic mind-body constitution and
            understand the deeper patterns shaping your energy,
            health, emotions and wellbeing.
          </p>

          <p
            className="
              text-white/70
              text-[15px]
              leading-8
              mb-6
            "
          >
            Answer honestly based on your natural tendencies.
            If you are above 40, answer based on yourself
            between ages 20–35.
          </p>

          <Button
            variant="primary"
            size="md"
            text="Start Quiz"
            onClick={onStart}
          />
        </div>
      </div>
    </div>
  </div>
);


const QuizPage = ({ onComplete }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState(Array(quizData.length).fill(null));
  const [error, setError] = useState("");

  const handleAnswerClick = (option) => {
    const updatedAnswers = [...answers];
    updatedAnswers[currentQuestion] = option;
    setAnswers(updatedAnswers);
    setError("");
  };

  const handleNext = () => {
    if (answers[currentQuestion] === null) {
      setError("Please select an option to proceed.");
      return;
    }
    setError("");
    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      onComplete(answers);
    }
  };

  const handlePrev = () => {
    setError("");
    if (currentQuestion > 0) setCurrentQuestion(currentQuestion - 1);
  };

  const progressPercentage = ((currentQuestion + 1) / quizData.length) * 100;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <div className="w-full max-w-2xl bg-white p-6 rounded-lg shadow-md text-center">
        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-2">
            Question {currentQuestion + 1} of {quizData.length}
          </p>
          <div className="w-full bg-gray-200 h-2 rounded-full">
            <div className="bg-primary h-2 rounded-full" style={{ width: `${progressPercentage}%` }}></div>
          </div>
        </div>
        <h2 className="text-xl font-semibold text-secondary mb-4">{quizData[currentQuestion].question}</h2>
        <div className="grid grid-cols-1 gap-4">
          {quizData[currentQuestion].options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleAnswerClick(option)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                answers[currentQuestion] === option ? "bg-primary text-white" : "bg-gray-200 text-gray-700"
              }`}
            >
              {option}
            </button>
          ))}
        </div>
        {error && <p className="mt-4 text-red-500 text-sm">{error}</p>}
      </div>
      <div className="flex mt-6 space-x-4">
        {currentQuestion > 0 && <Button onClick={handlePrev} text="Previous" variant="whitish" />}
        <Button
          onClick={handleNext}
          text={currentQuestion === quizData.length - 1 ? "Submit" : "Next"}
          variant="primary"
        />
      </div>
    </div>
  );
};

const ResultPage = ({ results, onRetake }) => (
  <div className="min-h-screen bg-[#F7F1EA] px-6 py-12 flex items-center justify-center">
    <div
      className="
        relative
        overflow-hidden
        rounded-[34px]
        max-w-5xl
        w-full
        h-[650px]
        shadow-[0_30px_80px_rgba(20,10,0,.12)]
      "
    >
      <img
        src="/assets/knowyourself/quiz/q2.jpg"
        alt="Dosha Result"
        className="
          w-full
          h-full
          object-cover
          brightness-[.84]
          saturate-[.9]
        "
      />

      <div
        className="
          absolute
          inset-0
          bg-gradient-to-t
          from-black/90
          via-black/35
          to-transparent
        "
      />

      <div className="absolute top-6 left-6">
        <div
          className="
            px-4
            py-2
            rounded-full
            bg-white/10
            backdrop-blur-xl
            border
            border-white/10
            text-white
            text-xs
            tracking-[.08em]
          "
        >
          YOUR RESULT
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 p-6">
        <div
          className="
            rounded-[28px]
            bg-white/10
            backdrop-blur-2xl
            border
            border-white/10
            p-8
          "
        >
          <h2
            className="
              text-[34px]
              md:text-[52px]
              leading-[1.05]
              tracking-[-0.03em]
              text-white
              mb-5
            "
          >
            Your Dosha Analysis
          </h2>

          <div className="mb-5">
            <p className="text-white text-lg mb-2">
              <span className="text-[#F6A04D] font-semibold">
                Primary Dosha:
              </span>{" "}
              {results.primary}
            </p>

            {results.secondary && (
              <p className="text-white text-lg">
                <span className="text-[#F6A04D] font-semibold">
                  Secondary Dosha:
                </span>{" "}
                {results.secondary}
              </p>
            )}
          </div>

          <p
            className="
              text-white/75
              text-[15px]
              leading-8
              mb-6
              max-w-2xl
            "
          >
            Download your free guide to understand your
            Ayurvedic constitution and discover the ideal
            diet, lifestyle, and practices for long-term
            balance and wellbeing.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="/Prakriti Management Guide_Param Life.pdf"
              className="
                inline-flex
                items-center
                justify-center
                px-6
                h-12
                rounded-full
                bg-white
                text-secondary
                font-medium
              "
            >
              Download Guide
            </a>

            <Button
              onClick={onRetake}
              text="Retake Quiz"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const PrakritiQuiz = () => {
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [results, setResults] = useState(null);

  const startQuiz = () => setQuizStarted(true);

  const calculateResults = (answers) => {
    let vata = 0, pitta = 0, kapha = 0;

    answers.forEach((answer, index) => {
      const optionIndex = quizData[index].options.indexOf(answer);
      if (optionIndex === 0) vata++;
      if (optionIndex === 1) pitta++;
      if (optionIndex === 2) kapha++;
    });

    const scores = [
      { dosha: "Vata", count: vata },
      { dosha: "Pitta", count: pitta },
      { dosha: "Kapha", count: kapha }
    ].sort((a, b) => b.count - a.count);

    let primary = scores[0].dosha;
    let secondary = scores[1].count > 0 ? scores[1].dosha : null;

    // If all answers are the same dosha
    if (
      (vata === answers.length) ||
      (pitta === answers.length) ||
      (kapha === answers.length)
    ) {
      secondary = null;
    }

    // Handle ties
    if (scores[0].count === scores[1].count && secondary) {
      primary = `${scores[0].dosha} & ${scores[1].dosha}`;
      secondary = scores[2].count > 0 ? scores[2].dosha : null;
    }

    return { primary, secondary };
  };

  const completeQuiz = (answers) => {
    const results = calculateResults(answers);
    setResults(results);
    setQuizCompleted(true);
  };

  const retakeQuiz = () => {
    setQuizStarted(false);
    setQuizCompleted(false);
    setResults(null);
  };

  return (
    <div>
      {!quizStarted ? (
        <IntroPage onStart={startQuiz} />
      ) : quizCompleted ? (
        <ResultPage results={results} onRetake={retakeQuiz} />
      ) : (
        <QuizPage onComplete={completeQuiz} />
      )}
    </div>
  );
};

export default PrakritiQuiz;
